import CalendarSettings from './components/CalendarSettings';

export default CalendarSettings;
